export default __webpack_public_path__ + "assets/labpasteur-component.e6aefcf4.svg";